// Catálogo fijo de continentes para el select. Mantener en sincronía
// con el back (SeaportsService.importMany valida contra la misma lista).
export const CONTINENTES = [
  'América del Norte',
  'América del Sur',
  'América Central',
  'Europa',
  'Asia',
  'África',
  'Oceanía',
  'Antártida',
];

// Tipos de terminal. Debe coincidir con el enum del schema
// `Seaport.tipoTerminal` y con TIPOS_TERMINAL_VALIDOS del service.
export const TIPOS_TERMINAL = ['Marítimo', 'Fluvial', 'Puerto seco'];

// Definición de campos del formulario (DynamicFormModal).
export const seaportFormFields = [
  {
    id: 'nombre',
    label: 'Nombre del puerto',
    type: 'text',
    required: true,
    placeholder: 'Ej. Puerto de Buenaventura',
  },
  {
    id: 'unlocode',
    label: 'UN/LOCODE',
    type: 'text',
    required: true,
    placeholder: 'COBUN',
    maxLength: 5,
  },
  {
    id: 'codigoLocal',
    label: 'Código local',
    type: 'text',
    required: false,
    placeholder: 'Opcional — código de aduana nacional',
    maxLength: 10,
  },
  { id: 'ciudad', label: 'Ciudad', type: 'text', required: true, placeholder: 'Buenaventura' },
  { id: 'pais', label: 'País', type: 'text', required: true, placeholder: 'Colombia' },
  {
    id: 'continente',
    label: 'Continente',
    type: 'select',
    required: false,
    options: [
      { value: '', label: '— Sin especificar —' },
      ...CONTINENTES.map((c) => ({ value: c, label: c })),
    ],
  },
  {
    id: 'tipoTerminal',
    label: 'Tipo de terminal',
    type: 'select',
    required: true,
    defaultValue: 'Marítimo',
    options: TIPOS_TERMINAL.map((t) => ({ value: t, label: t })),
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: true,
    defaultValue: 'Activo',
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
];

// Columnas del Excel (cabeceras tal cual aparecen en el archivo).
// El import normaliza mayúsculas / sin acentos al recibir las filas.
export const columnsExcel = [
  { key: 'nombre', header: 'Nombre' },
  { key: 'unlocode', header: 'UNLOCODE' },
  { key: 'codigoLocal', header: 'CodigoLocal' },
  { key: 'ciudad', header: 'Ciudad' },
  { key: 'pais', header: 'País' },
  { key: 'continente', header: 'Continente' },
  { key: 'tipoTerminal', header: 'TipoTerminal' },
  { key: 'estado', header: 'Estado' },
  { key: 'updatedAt', header: 'Última actualización' },
];
